import { render, staticRenderFns } from "./OfertaVopsit.vue?vue&type=template&id=162c9bed&scoped=true"
import script from "./OfertaVopsit.vue?vue&type=script&lang=js"
export * from "./OfertaVopsit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162c9bed",
  null
  
)

export default component.exports